<template>
  <div v-if="thisMonth" class="container-day"
       @dragover="onDragOver"
       @drop="onDrop"
       :class="{ 'drag-over': isDragOver }">
<!--    <div class="day" :style="{ height: size, width: size }"-->
<!--         @click="$emit('clickedDay', date)"-->
<!--         :class="{ today: isToday() }">-->
    <div class="day" :class="{ today: isToday() }" @click="$emit('clickedDay', date)">
      <span>{{ day }}</span>
    </div>

    <div v-show="modalEventInfo" ref="modalEvent" class="modal-event-info">
      <div class="title-modal-event-info">
        <span><strong>{{ date | date }}</strong></span>
        <span><x-icon class="close" @click="toggleInfo"/></span>
      </div>
      <div v-for="event in calendars" :key="event.id" class="event event-truncate" :title="event.title"
           :style="{background: eventColor(event)}"
           @click="$emit('clickCalendar', event)">
        {{ event.title }}
      </div>
    </div>

    <div v-show="!modalEventInfo" v-if="calendars.length > 0" class="event-container">
      <div v-for="event in firstCalendars" :key="event.id" 
           class="event event-truncate"
           :style="{background: eventColor(event)}" 
           :title="event.title"
           :draggable="event.type !== 'global'"
           @click="$emit('clickCalendar', event)"
           @dragstart="onDragStart(event, $event)"
           @dragend="onDragEnd">
        {{ event.title }}
      </div>

      <div v-if=" calendars.length - 2 > 0" class="event event-info event-truncate" @click="toggleInfo()">
        <strong>Mais {{ calendars.length - 2 }} evento(s)</strong>
      </div>
    </div>

  </div>

  <div v-else class="other-month">
    <div class="day">
      <span>{{ day }}</span>
    </div>
  </div>

</template>

<script>
  import { XIcon } from 'vue-feather-icons'

  export default {
    components: { XIcon },
    computed: {
      currentDay(){
        let date = new Date()
        let day = date.getDay() + 1
        return day
      },
      currentYear(){
        let date = new Date()
        let year = date.getFullYear()
        return year
      },
      day() {
        return this.date.getUTCDate()
      },
      firstCalendars() {
        return this.calendars.slice(0, 2)
      },
      size() {
        return Math.min(this.width, this.height) * 0.9 + 'px'
      },
      thisMonth() {
        return this.currentMonth === this.date.getMonth() + 1
      },
    },
    created() {
    },
    data() {
      return {
        height: 0,
        modalEventInfo: false,
        width: 0,
        isDragOver: false,
        draggedEvent: null
      }
    },
    methods: {
      eventColor(calendar) {
        return calendar.color || '#777777'
      },
      fixPositionModal() {
        let el = this.$refs.modalEvent
        let rect = el.getBoundingClientRect()
        let rectParent = el.closest('.calendar-table').getBoundingClientRect()

        if (rectParent.right < rect.right) {
          let diff = rectParent.right - rect.right
          el.style.left = diff + 'px'
        }
      },
      isToday() {
        let date = new Date()
        return date.getUTCDate() === this.date.getUTCDate() &&
            date.getFullYear() === this.date.getFullYear() &&
            date.getMonth() === this.date.getMonth()
      },
      toggleInfo() {
        this.modalEventInfo = !this.modalEventInfo
      },
      onDragStart(event, dragEvent) {
        this.draggedEvent = event
        dragEvent.dataTransfer.setData('text/plain', JSON.stringify({
          id: event.id,
          title: event.title
        }))
        dragEvent.dataTransfer.effectAllowed = 'move'
      },
      onDragEnd() {
        this.draggedEvent = null
      },
      onDragOver(event) {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'
        this.isDragOver = true
      },
      onDrop(event) {
        event.preventDefault()
        this.isDragOver = false
        
        const dragData = JSON.parse(event.dataTransfer.getData('text/plain'))
        const newDate = this.date.toISOString().split('T')[0]
        
        this.$emit('event-dropped', {
          eventId: dragData.id,
          newDate: newDate,
          originalEvent: this.draggedEvent
        })
      }
    },
    mounted() {
      // const myObserver = new ResizeObserver(entries => {
      //   entries.forEach(entry => {
      //     this.width = entry.contentRect.width
      //     this.height = entry.contentRect.height
      //   })
      // })
      // const element = document.querySelector('.container-day')
      // myObserver.observe(element)
    },
    name: 'Day',
    props: {
      calendars: { default: () => [], type: Array},
      currentMonth: { required: true },
      date: { required: true, type: Date },
    },
    updated() {
      if (this.modalEventInfo)
        this.fixPositionModal()
    },
    watch: {
      calendars() {
        this.modalEventInfo = false
      }
    }
  }
</script>

<style scoped>

  /*.container-day {*/
  /*  height: 100%;*/
  /*  display: flex;*/
  /*  align-items: center;*/
  /*  justify-content: center;*/
  /*  position: relative;*/
  /*  border: 1px solid rgb(218, 220, 224, 0.5);*/
  /*}*/

  .container-day {
    height: 100%;
    position: relative;
    transition: background-color 0.2s ease;

    &.drag-over {
      background-color: var(--primary-color);
      opacity: 0.3;
    }
  }

  .other-month {
    height: 100%;
    background-color: var(--light-gray);
  }

  /*.day {*/
  /*  position: absolute;*/
  /*  display: flex;*/
  /*  justify-content: center;*/
  /*  align-items: center;*/
  /*  border-radius: 50%;*/
  /*}*/

  .day {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    font-size: 12px;

    width: 30px;
    height: 30px;
  }

  .container-day .day:hover {
    background-color: var(--primary-color);
    cursor: pointer;
    font-size: medium;
    color: var(--white-bg);
  }

  .today {
    background-color: var(--primary-color-active);
    color: var(--white-bg);
  }

  .event-container {
    position: absolute;
    bottom: 0;

    width: 100%;
    max-height: 50%;

    display: flex;
    flex-direction: column;
  }

  .event {
    width: 100%;
    /*height: 16px;*/
    font-size: x-small;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 2px;
    padding: 3px 10px 3px 10px;
    font-size: 12px;
    transition: opacity 0.2s ease;
    color: var(--white-bg);
    background-color: var(--primary-color);

    &[draggable="true"] {
      cursor: grab;

      &:active {
        cursor: grabbing;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .event:hover{
    opacity: 0.9;
  }

  .event-truncate {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .event-info {
    color: var(--primary-text-color);
    background: var(--light-gray);
  }

  .event-info:hover{
    background: var(--border-color);
  }

  .modal-event-info {
    position: absolute;
    background-color: var(--white-bg);
    padding: 10px;
    width: 270px;
    height: 280px;
    z-index: 1;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.2);
    border: 1px solid var(--border-color);
  }

  .modal-event-info .event{
    color: var(--white-bg);
  }

  .title-modal-event-info {
    color: var(--primary-text-color);
  }

  .title-modal-event-info {
    font-size: small;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .title-modal-event-info .close {
    cursor: pointer;
  }

</style>
